/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentData, ContainerModel, ComponentModel, ComponentFieldKey, TextModel } from '@typescript-kit/view';
import { TimeRecordingComponentKey } from '../key/time-recording-component.key';

export interface TimeRecordingSidebarData extends ComponentData {
  summaryHeader?: TextModel;
  summary?: ContainerModel;
  summaryExpanded?: boolean;
  workingHoursHeader?: TextModel;
  workingHours?: ContainerModel;
  workingHoursExpanded?: boolean;
  width?: string;
}

export class TimeRecordingSidebarKey {
  static readonly SUMMARY_HEADER = 'summaryHeader';
  static readonly SUMMARY = 'summary';
  static readonly SUMMARY_EXPANDED = 'summaryExpanded';
  static readonly WORKING_HOURS_HEADER = 'workingHoursHeader';
  static readonly WORKING_HOURS = 'workingHours';
  static readonly WORKING_HOURS_EXPANDED = 'workingHoursExpanded';
  static readonly WIDTH = 'width';
}

export class TimeRecordingSidebarModel extends ComponentModel implements TimeRecordingSidebarData {

  static readonly KEYS = ComponentModel.KEYS.concat(
    Object.keys(TimeRecordingSidebarKey).map((key) => TimeRecordingSidebarKey[key])
  );

  constructor(data?: TimeRecordingSidebarData) {
    super(data, TimeRecordingSidebarModel.KEYS);
  }

  get summaryHeader(): TextModel {
    return this.get(TimeRecordingSidebarKey.SUMMARY_HEADER);
  }

  set summaryHeader(value: TextModel) {
    this.set(TimeRecordingSidebarKey.SUMMARY_HEADER, value);
  }

  get summary(): ContainerModel {
    return this.get(TimeRecordingSidebarKey.SUMMARY);
  }

  set summary(value: ContainerModel) {
    this.set(TimeRecordingSidebarKey.SUMMARY, value);
  }

  get summaryExpanded(): boolean {
    return this.get(TimeRecordingSidebarKey.SUMMARY_EXPANDED, true);
  }

  set summaryExpanded(value: boolean) {
    this.set(TimeRecordingSidebarKey.SUMMARY_EXPANDED, value);
  }

  get workingHoursHeader(): TextModel {
    return this.get(TimeRecordingSidebarKey.WORKING_HOURS_HEADER);
  }

  set workingHoursHeader(value: TextModel) {
    this.set(TimeRecordingSidebarKey.WORKING_HOURS_HEADER, value);
  }

  get workingHours(): ContainerModel {
    return this.get(TimeRecordingSidebarKey.WORKING_HOURS);
  }

  set workingHours(value: ContainerModel) {
    this.set(TimeRecordingSidebarKey.WORKING_HOURS, value);
  }

  get workingHoursExpanded(): boolean {
    return this.get(TimeRecordingSidebarKey.WORKING_HOURS_EXPANDED, true);
  }

  set workingHoursExpanded(value: boolean) {
    this.set(TimeRecordingSidebarKey.WORKING_HOURS_EXPANDED, value);
  }

  get width(): string {
    return this.get(TimeRecordingSidebarKey.WIDTH);
  }

  set width(value: string) {
    this.set(TimeRecordingSidebarKey.WIDTH, value);
  }

  protected setupValues(values: TimeRecordingSidebarData, exclusive: boolean): TimeRecordingSidebarData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = TimeRecordingComponentKey.TIME_RECORDING_SIDEBAR;
    }
    return super.setupValues(values, exclusive) as TimeRecordingSidebarData;
  }

}
